import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import routes from 'routes';
import Table from 'components/widgets/table';
import { valuationConfigs as sampleConfigs } from './valuersData';
import { ModalContext } from 'context/ModalContext';
import AddValuationConfig from 'components/widgets/modals/AddValuationConfig';
import { register_valuer_config } from 'services/apiSrv';
import { fetch_product_valuation_config } from 'services/apiSrv';
import { useQuery, useQueryClient } from 'react-query';

export default function ValuationConfig() {
  const history = useHistory();
  const [configs, setConfigs] = useState(() => {
    // clone and add index
    return sampleConfigs.map((c, i) => ({ ...c, index: i + 1 }));
  });
  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
  const queryClient = useQueryClient()

  const handleView = (id) => {
    const cfg = configs.find((c) => c.id === id) || sampleConfigs.find((c) => c.id === id);
    const path = routes.valuationConfigView.replace(':id', id);
    if (cfg) history.push(path, { config: cfg });
    else history.push(path);
  };

  // Open the Add Config modal
  const handleAdd = () => {
    setModalShow(true);
  };

  const onAddConfig = async(newCfg) => {
    setConfigs((prev) => {
      const updated = [newCfg, ...prev];
      return updated.map((c, i) => ({ ...c, index: i + 1 }));
    });
    const res= await register_valuer_config(newCfg)
      queryClient.invalidateQueries('product-valuation-config');

    return res
  };

    async function get_product_valuation_config(){
    const res = await fetch_product_valuation_config()
    return res.data 
  }

  const { data: valConfigs = [], isLoading, error: configError,  refetch } = useQuery({
    queryKey: ['product-valuation-config'],
    queryFn: async () => {
      const res = await get_product_valuation_config();
      if (res.error) throw new Error(res.error.message);
      return res;
    },
  });



  // console.log("configs val", valConfigs)

  const tableFields = [
    // { name: '#' },
    { name: 'Name' },
    { name: 'Description' },
    { name: 'Max Period' },
    { name: 'Created At' },
    // { name: 'Actions' },
  ];

  const rowData = [
    // { type: 'text', field: 'index' },
    { type: 'text', field: 'valuationConfigName' },
    { type: 'text', field: 'valuationConfigDescription' },
    { type: 'text', field: 'maximumValuationPeriod' },
    { type: 'date', field: 'createdAt' },
    // {
    //   type: 'action',
    //   actions: [{ method: handleView, field: 'id', title: 'View' }],
    // },
  ];

  return (
    <main style={{ padding: 24 }}>
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1>Valuation Configuration</h1>
      </div>

      <section style={{ marginTop: 24 }}>
        <div className="mb-3 d-flex justify-content-end">
          <button className="btn btn-primary" onClick={handleAdd}>
            <i className="fas fa-plus mr-2"></i> Add Configuration
          </button>
        </div>

        <Table title="Valuation Configs" table_fields={tableFields} row_data={rowData} table_data={valConfigs} pageSize={10} />
        <AddValuationConfig show={modalShow} onHide={modalClose} onAdd={onAddConfig} />
      </section>
    </main>
  );
}
